import React, {useState} from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import SearchIcon from '@material-ui/icons/Search'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import FilterListIcon from '@material-ui/icons/FilterList'
import {Typography} from '@material-ui/core'
import PopFieldToggle from './PopFieldToggle'

const FieldFilter = ({options = [], value = [], onChange, objects}) => {
  const [elRef, setElRef] = useState(null)

  const handleClick = e => {
    setElRef(e.target)
  }

  const handleClose = (e, filters) => {
    setElRef(null)
    onChange(e, filters)
  }

  const handleToggleField = (e, field) => {
    let _fields = [...value]
    const index = _fields.findIndex(f => f.field_id === field.field_id)
    if (index !== -1) {
      _fields.splice(index, 1)
    } else {
      _fields.push(field)
    }
    if (onChange) {
      onChange(e, _fields)
    }
  }

  return (
    <>
      {elRef ? (
        <span
          onClick={handleClick}
          style={{
            border: '1px solid #3473ff',
            borderRadius: 18.5,
            color: '#3473ff',
            cursor: 'pointer',
          }}
        >
          <FilterListIcon style={{pointerEvents: 'none'}} />
          <span className="ap-typography ap-typography--sm" style={{color: '#3473ff'}}>
            Filter
          </span>
        </span>
      ) : (
        <span onClick={handleClick} style={{cursor: 'pointer'}}>
          <FilterListIcon style={{pointerEvents: 'none'}} />
        </span>
      )}

      <PopFieldToggle
        open={!!elRef}
        anchorEl={elRef}
        onClose={handleClose}
        options={options}
        objects={objects}
        value={value}
        onClickOption={handleToggleField}
      />
    </>
  )
}

export default FieldFilter
